"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.INTERACTION_TYPES = void 0;

require("core-js/modules/es6.array.map.js");

require("core-js/modules/es6.object.keys.js");

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _get = _interopRequireDefault(require("lodash/get"));

// eslint-disable-next-line import/no-extraneous-dependencies -- directive added automatically by Shepherd migration
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

/**
 * Mapping of supported React synthetic event handlers to element interaction event type
 * react events: https://facebook.github.io/react/docs/events.html
 * element interaction schema: https://github.com/NerdWallet/schemas/blob/master/protobuf/src/event/ElementInteractionTypeEnum.proto
 */
var INTERACTION_TYPES = {
  CLICK: 'onClick',
  HOVER: 'onMouseOver',
  MOUSE_DOWN: 'onMouseDown',
  MOUSE_UP: 'onMouseUp',
  MOUSE_ENTER: 'onMouseEnter',
  MOUSE_LEAVE: 'onMouseLeave',
  KEY_DOWN: 'onKeyDown',
  KEY_UP: 'onKeyUp',
  KEY_PRESS: 'onKeyPress',
  LOAD: 'onLoad',
  DRAG: 'onDrag',
  DRAG_START: 'onDragStart',
  DRAG_END: 'onDragEnd',
  DRAG_ENTER: 'onDragEnter',
  DRAG_LEAVE: 'onDragLeave',
  DRAG_OVER: 'onDragOver',
  DROP: 'onDrop',
  PLAY: 'onPlay',
  PAUSE: 'onPause',
  ANIMATE_START: 'onAnimationStart',
  ANIMATE_END: 'onAnimationEnd',
  COPY: 'onCopy',
  CUT: 'onCut',
  PASTE: 'onPaste',
  TOUCH_START: 'onTouchStart',
  TOUCH_END: 'onTouchEnd',
  TOUCH_CANCEL: 'onTouchCancel',
  TOUCH_MOVE: 'onTouchMove'
};
exports.INTERACTION_TYPES = INTERACTION_TYPES;

var ElementInteraction = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(ElementInteraction, _React$Component);

  var _super = (0, _createSuper2.default)(ElementInteraction);

  function ElementInteraction() {
    (0, _classCallCheck2.default)(this, ElementInteraction);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(ElementInteraction, [{
    key: "fireElementInteraction",
    value: function fireElementInteraction(interactionType) {
      if (typeof window === 'undefined' || !window.nwa) {
        return;
      } // Try to grab element dom types if not explictly passed in


      var childDOMNode = _reactDom.default.findDOMNode(this.child); // eslint-disable-line


      var elementDomType = // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      this.props.elementDomType || (0, _get.default)(childDOMNode, 'nodeName');
      var parentElementDomType = // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      this.props.parentElementDomType || (0, _get.default)(childDOMNode, 'parentNode.nodeName');
      var eventProps = (0, _objectSpread2.default)({
        // props.id is supported for consistency across other tracking components
        elementInteractionHeader: {
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          elementCategory: this.props.elementCategory,
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          elementContent: this.props.elementContent,
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          elementCount: this.props.elementCount,
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          elementDomId: this.props.elementDomId,
          elementDomType: elementDomType,
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          elementName: this.props.elementName || this.props.id,
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          elementPosition: this.props.elementPosition,
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          impressionId: this.props.impressionId,
          interactionType: interactionType,
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          pageNumber: this.props.pageNumber,
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          parentElementDomId: this.props.parentElementDomId,
          parentElementDomType: parentElementDomType,
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          sectionCategory: this.props.sectionCategory,
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          sectionElementCount: this.props.sectionElementCount,
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          sectionPosition: this.props.sectionPosition
        }
      }, this.props.verticalInteractionData); // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

      window.nwa.track(this.props.eventName, eventProps);
    } // Get the individual child or wrap the children if it is an array/function/string

  }, {
    key: "convertChildrenToChild",
    value: function convertChildrenToChild() {
      var _this = this;

      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      var Component = this.props.component; // Convert text to React Element
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

      if (typeof this.props.children === 'string') {
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        return /*#__PURE__*/_react.default.createElement(Component, null, this.props.children);
      } // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration


      if (Array.isArray(this.props.children)) {
        // Convert array to individual react element with children,
        // and pass `triggerImpression` to the array/function
        return /*#__PURE__*/_react.default.createElement(Component, null, _react.default.Children.map(this.props.children, function (child) {
          return _this.cloneChild(child);
        }));
      } // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration


      return this.props.children;
    }
  }, {
    key: "cloneChild",
    value: function cloneChild(child) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var childProps = (0, _objectSpread2.default)({}, props);

      if (typeof child.type !== 'string') {
        // `triggerInteraction` is a prop passed so the consumer can manually
        // trigger the element interaction event if they have a complex
        // interaction. The interaction type will need to be passed in
        // at the call site. It's _not_ passed to DOM elements.
        childProps.triggerInteraction = this.fireElementInteraction.bind(this);
      } // Add support for anonymous inline function


      if (typeof child === 'function') {
        return child(childProps);
      }

      return /*#__PURE__*/_react.default.cloneElement(_react.default.Children.only(child), childProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var child = this.convertChildrenToChild();
      var childProps = {
        ref: function ref(c) {
          _this2.child = c;
        }
      }; // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

      var interactions = [].concat(this.props.type);
      interactions.forEach(function (interaction) {
        var eventHandler = INTERACTION_TYPES[interaction]; // If the given child already has the associated event handler defined,
        // call both the element interaction event and the child event handler

        if (typeof (0, _get.default)(child, "props[".concat(eventHandler, "]")) === 'function') {
          var childEventHandler = child.props[eventHandler];

          childProps[eventHandler] = function () {
            _this2.fireElementInteraction(interaction);

            childEventHandler.apply(void 0, arguments);
          };
        } else {
          childProps[eventHandler] = _this2.fireElementInteraction.bind(_this2, interaction);
        }
      });
      return this.cloneChild(child, childProps);
    }
  }]);
  return ElementInteraction;
}(_react.default.Component);

var SUPPORTED_INTERACTIONS = Object.keys(INTERACTION_TYPES); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

ElementInteraction.defaultProps = {
  component: 'span',
  eventName: 'ELEMENT_INTERACTION_EVENT',
  verticalInteractionData: {}
}; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

ElementInteraction.displayName = 'ElementInteraction'; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

ElementInteraction.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
  children: _propTypes.default.any.isRequired,
  // If you pass in an array of children or a text, it will be wrapped with this node type.
  component: _propTypes.default.string,
  // The type of the element; this should be treated as an enum.
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  elementCategory: _propTypes.default.string,
  // Content of the element.
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  elementContent: _propTypes.default.string,
  // The total number of elements on the page.
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  elementCount: _propTypes.default.number,
  // The DOM type of the element ('button', 'a').
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  elementDomType: _propTypes.default.string,
  // The DOM ID of the element
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  elementDomId: _propTypes.default.number,
  // The name of the element the user is interacting with
  elementName: _propTypes.default.string.isRequired,
  // The position of the element in the section.
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  elementPosition: _propTypes.default.number,
  // Name of the element interaction event to be fired
  eventName: _propTypes.default.string,
  // Unique id that maps to the `elementName` in the DWH schema
  // We use the id here so it is consistent across other tracking
  // components.
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  id: _propTypes.default.string,
  // Unique impression id.
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  impressionId: _propTypes.default.string,
  // The page number on paginated output.
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  pageNumber: _propTypes.default.number,
  // The DOM ID of the parent element
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  parentElementDomId: _propTypes.default.string,
  // The DOM type of the parent element.
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  parentElementDomType: _propTypes.default.string,
  // The type of the section the element is in (e.g. recommendations, related-content).
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  sectionCategory: _propTypes.default.string,
  // The number of elements in the section.
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  sectionElementCount: _propTypes.default.number,
  // The position order of the section in the page.
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  sectionPosition: _propTypes.default.number,
  // The interaction type
  type: _propTypes.default.oneOfType([_propTypes.default.oneOf(SUPPORTED_INTERACTIONS), _propTypes.default.arrayOf(SUPPORTED_INTERACTIONS)]).isRequired,
  // Vertical specific tracking data
  // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
  verticalInteractionData: _propTypes.default.object
};
var _default = ElementInteraction;
exports.default = _default;